import Button from '@berlitz/button'
import Card from '@berlitz/card'
import { H3 } from '@berlitz/globals'
import styled from 'styled-components'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => theme.palette.blueGray50};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  margin-top: ${({ theme }) => theme.space.xs};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: center;
  }
`

export const Icon = styled.div<{ iconColor?: string }>`
  span {
    margin: auto;
    width: ${({ theme }) => theme.layout.lg};
    height: ${({ theme }) => theme.layout.lg};
    border-radius: ${({ theme }) => theme.layout.lg};
    background-color: ${({ theme, iconColor = 'blue' }) => theme.palette[`${iconColor}10`]};

    @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
      width: 56px;
      height: 56px;
    }

    svg {
      vertical-align: middle;
      margin: auto;
      color: ${({ theme, iconColor = 'blue' }) => theme.palette[`${iconColor}100`]};

      &:last-child {
        margin-bottom: auto;
      }
    }
  }
`

export const Wrapper = styled.div`
  height: max-content;
  line-height: 1.14;

  span {
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`

export const InfoWrapper = styled.div`
  color: ${({ theme }) => theme.colors.brandPrimary};
  span {
    display: inline-flex;
    vertical-align: middle;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 238px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: max-content;
    flex-direction: column;
  }
`

export const StyledCard = styled(Card)<{ color?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 238px;
  ${({ color, theme }) =>
    color &&
    `
    background: ${theme.palette[color]};
  `};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: max-content;
  }
`

export const TextLoaderContainer = styled.div`
  margin: ${({ theme }) => theme.space.xs};
`

export const Title = styled(H3)`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  & > span {
    font-weight: ${({ theme }) => theme.fontWeight.bold};
  }
  margin: ${({ theme }) => theme.space.xs};
  vertical-align: middle;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-block-start: 0;
  }
`

export const StyledA = styled.a`
  cursor: pointer;
  text-decoration: none;
  outline: none;
`

export const ButtonSmaller = styled(Button)`
  padding: ${({ theme }) => `${theme.space.xs} ${theme.space.lg}`};
`
